import { CLICK_CONVERSION_LOGS_DELETION_STATUS, CLICK_CONVERSION_LOGS_STATUS, PRODUCT_TYPE_IDS } from "helpers/sf_constants"
import {
  GET_CLICK_CONVERSION_PIXELS,
  GET_CLICK_CONVERSION_PIXELS_SUCCESS,
  GET_CLICK_CONVERSION_PIXELS_ERROR,
  MODIFY_CLICK_CONVERSION_PIXELS,
  MODIFY_CLICK_CONVERSION_PIXELS_SUCCESS,
  MODIFY_CLICK_CONVERSION_PIXELS_ERROR,
  ADD_CLICK_CONVERSION_PIXEL,
  ADD_CLICK_CONVERSION_PIXEL_SUCCESS,
  ADD_CLICK_CONVERSION_PIXEL_ERROR,
  DELETE_CLICK_CONVERSION_PIXEL,
  DELETE_CLICK_CONVERSION_PIXEL_SUCCESS,
  DELETE_CLICK_CONVERSION_PIXEL_ERROR,
  GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS,
  GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_SUCCESS,
  GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_ERROR,
  GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
  GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
  GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
  ADD_CLICK_IMPORT_CONVERSION_PIXEL,
  GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS,
  GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
  GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
  GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS,
  GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
  GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
  GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS,
  GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS,
  GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR,
  ADD_CLICK_IMPORT_CONVERSION_PIXEL_SUCCESS,
  ADD_CLICK_IMPORT_CONVERSION_PIXEL_ERROR,
  GET_CLICK_CONVERSION_LOGS,
  GET_CLICK_CONVERSION_LOGS_SUCCESS,
  GET_CLICK_CONVERSION_LOGS_ERROR,
  RESET_CLICK_CONVERSION,
  RESET_RELOAD_CONVERSION_LOG,
  GET_CLICK_CONVERSION_LOG_BY_ID,
  GET_CLICK_CONVERSION_LOG_BY_ID_SUCCESS,
  GET_CLICK_CONVERSION_LOG_BY_ID_ERROR,
  GET_PRESIGNED_URL,
  UPLOAD_FILE_TO_URL,
  GET_STATUS_OF_LOGS_BY_IDS,
  GET_STATUS_OF_LOGS_BY_IDS_SUCCESS,
  GET_STATUS_OF_LOGS_BY_IDS_ERROR,
  DOWNLOAD_BULK_CONVERSIONS_FILE,
  DOWNLOAD_BULK_CONVERSIONS_FILE_SUCCESS,
  DOWNLOAD_BULK_CONVERSIONS_FILE_ERROR,
  DELETE_CLICK_CONVERSION_LOG,
  DELETE_CLICK_CONVERSION_LOG_SUCCESS,
  DELETE_CLICK_CONVERSION_LOG_ERROR,
  GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES,
  GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS,
  GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_ERROR,
  GET_CALL_CONVERSION_PIXELS_AGG_PROFILES,
  GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS,
  GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_ERROR,
  GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
  GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
  GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
  GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES,
  GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS,
  GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR,
  GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3,
  GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_SUCCESS,
  GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_ERROR,
  GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3,
  GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_SUCCESS,
  GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_ERROR,
  GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3,
  GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_SUCCESS,
  GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_ERROR
} from "./actionTypes"
import _ from "lodash"

const initialState = {
  click_conversion_pixels: [],
  error: null,
  loading: false,
  click_conversion_pixels_agg_ad_groups: [],
  click_conversion_pixels_agg_source_types: [],
  click_conversion_pixels_agg_campaigns: [],
  lead_conversion_pixels_agg_campaigns: [],
  lead_conversion_pixels_agg_profiles: [],
  lead_conversion_pixels_agg_source_types: [],
  call_conversion_pixels_agg_campaigns: [],
  call_conversion_pixels_agg_profiles: [],
  call_conversion_pixels_agg_source_types: [],
  lead_conversion_pixels_agg_loading: false,
  call_conversion_pixels_agg_loading: false,
  last_conversion_log_id: null,
  click_conversion_import_error: null,
  last_conversion_action: null,
  reload: null,
  click_conversion_logs: [],
  current_conversion_log: {},
  last_page_fetched: 0,
  total_number_of_pages: 0,
  click_conversion_logs_loading: null,
  downloading_log_ids: [],
  get_presigned_url_loading: false
}

const transformV3AggDataToV1AggData = (data, action_type) => {
  const v1_click_conversion_fields = {
    revenue: 'click_conversions_revenue',
    conversions: 'click_conversions_count'
  }
  const v1_lead_conversion_fields = {
    revenue: 'lead_conversions_revenue',
    conversions: 'lead_conversions_count'
  }
  const v1_call_conversion_fields = {
    revenue: 'call_conversions_revenue',
    conversions: 'call_conversions_count'
  }
  const v3_conversion_fields = {
    revenue: 'conversions_revenue',
    conversions: 'conversions_count',
    product_type_id: 'product_type_id'
  }

  let clicks = [];
  let calls = [];
  let leads = [];
  for (const curr of data) {
    if (curr.product_type_id === PRODUCT_TYPE_IDS.LEADS) {
      leads.push(_.omit({
        ...curr,
        [v1_lead_conversion_fields.revenue]: curr[v3_conversion_fields.revenue],
        [v1_lead_conversion_fields.conversions]: curr[v3_conversion_fields.conversions]
      }, v3_conversion_fields));
    } else if (curr.product_type_id === PRODUCT_TYPE_IDS.CALLS) {
      calls.push(_.omit({
        ...curr,
        [v1_call_conversion_fields.revenue]: curr[v3_conversion_fields.revenue],
        [v1_call_conversion_fields.conversions]: curr[v3_conversion_fields.conversions]
      }, v3_conversion_fields));
    } else {
      clicks.push(_.omit({
        ...curr,
        [v1_click_conversion_fields.revenue]: curr[v3_conversion_fields.revenue],
        [v1_click_conversion_fields.conversions]: curr[v3_conversion_fields.conversions]
      }, v3_conversion_fields));
    }
  }

  switch(action_type) {
    case GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_SUCCESS:
      return {
        click_conversion_pixels_agg_ad_groups: clicks,
        lead_conversion_pixels_agg_profiles: leads,
        call_conversion_pixels_agg_profiles: calls
      }
    case GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_SUCCESS:
      return {
        click_conversion_pixels_agg_source_types: clicks,
        lead_conversion_pixels_agg_source_types: leads,
        call_conversion_pixels_agg_source_types: calls
      }
    case GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_SUCCESS:
      return {
        click_conversion_pixels_agg_campaigns: clicks,
        lead_conversion_pixels_agg_campaigns: leads,
        call_conversion_pixels_agg_campaigns: calls
      }
  }
}

const Conversions = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLICK_CONVERSION_PIXELS:
      return {
        ...state,
        loading: true
      }

    case GET_CLICK_CONVERSION_PIXELS_SUCCESS:
      return {
        ...state,
        click_conversion_pixels: action.payload,
        loading: false
      }

    case GET_CLICK_CONVERSION_PIXELS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case MODIFY_CLICK_CONVERSION_PIXELS:
      return {
        ...state,
        error: null,
        loading: true
      }

    case MODIFY_CLICK_CONVERSION_PIXELS_SUCCESS:
      return {
        ...state,
        click_conversion_pixels: state.click_conversion_pixels.map(ccp => ccp.id == action.payload.id
          ? action.payload
          : ccp,
        ),
        error: null,
        loading: false
      }

    case MODIFY_CLICK_CONVERSION_PIXELS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case ADD_CLICK_CONVERSION_PIXEL:
      return {
        ...state,
        error: null,
        loading: true
      }

    case ADD_CLICK_CONVERSION_PIXEL_SUCCESS:
      return {
        ...state,
        click_conversion_pixels: [...state.click_conversion_pixels, action.payload],
        error: null,
        loading: false
      }

    case ADD_CLICK_CONVERSION_PIXEL_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        get_presigned_url_loading: false
      }

    case DELETE_CLICK_CONVERSION_PIXEL:
      return {
        ...state,
        error: null,
        loading: true
      }

    case DELETE_CLICK_CONVERSION_PIXEL_SUCCESS:
      return {
        ...state,
        click_conversion_pixels: state.click_conversion_pixels.filter(e => e.id !== action.payload.id),
        error: null,
        loading: false
      }

    case DELETE_CLICK_CONVERSION_PIXEL_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS:
      return {
        ...state,
        loading: true
      }
    case GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_SUCCESS:
      return {
        ...state,
        click_conversion_pixels_agg_ad_groups: action.payload,
        loading: false
      }
    case GET_CLICK_CONVERSION_PIXELS_AGG_AD_GROUPS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3:
      return {
        ...state,
        loading: true
      }
    case GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_SUCCESS:
      return {
        ...state,
        ...transformV3AggDataToV1AggData(action.payload, action.type),
        loading: false
      }
    case GET_CONVERSION_PIXELS_AGG_AD_GROUPS_V3_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3:
      return {
        ...state,
        loading: true
      }
    case GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_SUCCESS:
      return {
        ...state,
        ...transformV3AggDataToV1AggData(action.payload, action.type),
        loading: false
      }
    case GET_CONVERSION_PIXELS_AGG_SOURCE_TYPES_V3_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3:
      return {
        ...state,
        loading: true
      }
    case GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_SUCCESS:
      return {
        ...state,
        ...transformV3AggDataToV1AggData(action.payload, action.type),
        loading: false
      }
    case GET_CONVERSION_PIXELS_AGG_CAMPAIGNS_V3_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }      
    case GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES:
      return {
        ...state,
        lead_conversion_pixels_agg_loading: true
      }
    case GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS:
      return {
        ...state,
        lead_conversion_pixels_agg_profiles: action.payload,
        lead_conversion_pixels_agg_loading: false
      }
    case GET_LEAD_CONVERSION_PIXELS_AGG_PROFILES_ERROR:
      return {
        ...state,
        error: action.payload,
        lead_conversion_pixels_agg_loading: false
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_PROFILES:
      return {
        ...state,
        call_conversion_pixels_agg_loading: true
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_SUCCESS:
      return {
        ...state,
        call_conversion_pixels_agg_profiles: action.payload,
        call_conversion_pixels_agg_loading: false
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_PROFILES_ERROR:
      return {
        ...state,
        error: action.payload,
        call_conversion_pixels_agg_loading: false
      }
    case GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS:
      return {
        ...state,
        loading: true
      }
    case GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        click_conversion_pixels_agg_campaigns: action.payload,
        loading: false
      }
    case GET_CLICK_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS:
      return {
        ...state,
        lead_conversion_pixels_agg_loading: true
      }
    case GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        lead_conversion_pixels_agg_campaigns: action.payload,
        lead_conversion_pixels_agg_loading: false
      }
    case GET_LEAD_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.payload,
        lead_conversion_pixels_agg_loading: false
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS:
      return {
        ...state,
        call_conversion_pixels_agg_loading: true
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        call_conversion_pixels_agg_campaigns: action.payload,
        call_conversion_pixels_agg_loading: false
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_CAMPAIGNS_ERROR:
      return {
        ...state,
        error: action.payload,
        call_conversion_pixels_agg_loading: false
      }
    case GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES:
      return {
        ...state,
        loading: true
      }
    case GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS:
      return {
        ...state,
        click_conversion_pixels_agg_source_types: action.payload,
        loading: false
      }
    case GET_CLICK_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES:
      return {
        ...state,
        lead_conversion_pixels_agg_loading: true
      }
    case GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS:
      return {
        ...state,
        lead_conversion_pixels_agg_source_types: action.payload,
        lead_conversion_pixels_agg_loading: false
      }
    case GET_LEAD_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR:
      return {
        ...state,
        error: action.payload,
        lead_conversion_pixels_agg_loading: false
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES:
      return {
        ...state,
        call_conversion_pixels_agg_loading: true
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_SUCCESS:
      return {
        ...state,
        call_conversion_pixels_agg_source_types: action.payload,
        call_conversion_pixels_agg_loading: false
      }
    case GET_CALL_CONVERSION_PIXELS_AGG_SOURCE_TYPES_ERROR:
      return {
        ...state,
        error: action.payload,
        call_conversion_pixels_agg_loading: false
      }
    case ADD_CLICK_IMPORT_CONVERSION_PIXEL:
      return {
        ...state,
        click_conversion_import_error: null,
        click_conversions: []
      }
    case ADD_CLICK_IMPORT_CONVERSION_PIXEL_SUCCESS:
      return {
        ...state,
        last_conversion_log_id: action.payload?.id,
        last_conversion_action: true,
        reload: true,
        click_conversion_logs_loading: false,
        click_conversion_logs: [action.payload, ...state.click_conversion_logs]
      }
    case ADD_CLICK_IMPORT_CONVERSION_PIXEL_ERROR:
      return {
        ...state,
        click_conversion_import_error: action.payload,
        last_conversion_action: true
      }

    case GET_CLICK_CONVERSION_LOGS:
      return {
        ...state,
        click_conversion_logs_loading: true
      }

    case GET_CLICK_CONVERSION_LOGS_SUCCESS:
      return {
        ...state,
        click_conversion_logs: action.payload,
        click_conversion_logs_loading: false,
      }
    case GET_CLICK_CONVERSION_LOGS_ERROR:
      return {
        ...state,
        error: action.payload,
        click_conversion_logs_loading: false
      }

    case GET_CLICK_CONVERSION_LOG_BY_ID:
      const page_number = action.payload.queryParams.page_number
      let click_conversion_log = state.current_conversion_log
      if (page_number === 1) {
        click_conversion_log.click_conversion_log_details = []
      }
      return {
        ...state,
        click_conversion_logs_loading: true,
        current_conversion_log: click_conversion_log,
        last_page_fetched: state.last_page_fetched,
      }

    case GET_CLICK_CONVERSION_LOG_BY_ID_SUCCESS:
      let uniqueClickConversionLogDetails = []
      const all_log_details = [...state.current_conversion_log?.click_conversion_log_details, ...action.payload.data.click_conversion_log_details]
      all_log_details.forEach(function (item) {
        const i = uniqueClickConversionLogDetails.findIndex(x => x.id == item.id);
        if (i <= -1) {
          uniqueClickConversionLogDetails.push(item)
        }
      });

      return {
        ...state,
        current_conversion_log: { ...action.payload.data, click_conversion_log_details: uniqueClickConversionLogDetails },
        last_page_fetched: parseInt(action.payload.additional_data?.page_number),
        total_number_of_pages: parseInt(action.payload.additional_data?.total_number_of_pages),
        click_conversion_logs_loading: false,
        reload: (action.payload?.status === CLICK_CONVERSION_LOGS_STATUS.PENDING || action.payload?.status === CLICK_CONVERSION_LOGS_STATUS.FILE_UPLOADED)
      }
    case GET_CLICK_CONVERSION_LOG_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
        click_conversion_logs_loading: false
      }
    case RESET_CLICK_CONVERSION:
      return {
        ...state,
        last_conversion_action: null,
        click_conversion_logs_loading: false,
      }
    case RESET_RELOAD_CONVERSION_LOG:
      return {
        ...state,
        reload: null
      }
    case GET_PRESIGNED_URL:
      return {
        ...state,
        click_conversion_import_error: null,
        click_conversions: [],
        click_conversion_logs_loading: true,
        get_presigned_url_loading: true
      }
    case UPLOAD_FILE_TO_URL:
      return {
        ...state,
        get_presigned_url_loading: false
      }
    case GET_STATUS_OF_LOGS_BY_IDS:
      return {
        ...state
      }
    case GET_STATUS_OF_LOGS_BY_IDS_SUCCESS:
      const incomingLogIds = action.payload?.map(log => log.id) || [];
      const updatedConversionLogs = [
        ...state.click_conversion_logs.filter(log => !incomingLogIds.includes(log.id)),
        ...action.payload?.filter(log => log.deletion_status !== CLICK_CONVERSION_LOGS_DELETION_STATUS.COMPLETED)
      ];
      return {
        ...state,
        click_conversion_logs_loading: false,
        click_conversion_logs: updatedConversionLogs
      }
    case GET_STATUS_OF_LOGS_BY_IDS_ERROR:
      return {
        ...state,
        click_conversion_logs_loading: false,
        error: action.payload
      }
    case DOWNLOAD_BULK_CONVERSIONS_FILE:
      return {
        ...state,
        downloading_log_ids: _.uniq([...state.downloading_log_ids, action?.payload?.conversion_log_id])
      }
    case DOWNLOAD_BULK_CONVERSIONS_FILE_SUCCESS:
      return {
        ...state,
        downloading_log_ids: state.downloading_log_ids.filter(id => id !== action?.payload?.conversion_log_id)
      }
    case DOWNLOAD_BULK_CONVERSIONS_FILE_ERROR:
      return {
        ...state,
        downloading_log_ids: state.downloading_log_ids.filter(id => id !== action?.payload?.conversion_log_id),
        error: action.error
      }
    case DELETE_CLICK_CONVERSION_LOG:
      return {
        ...state,
        click_conversion_logs_loading: true
      }
    case DELETE_CLICK_CONVERSION_LOG_SUCCESS:
      // Determine how to update the logs based on the feature flag
      const isAsyncDeletionEnabled = action.payload?.isAsyncDeletionEnabled;
      const conversion_logs = isAsyncDeletionEnabled
        ? state.click_conversion_logs.map(log => log.id === action.payload.id ? { ...log, ...action.payload } : log)
        : state.click_conversion_logs.filter(log => log.id !== action.payload.id);

      return {
        ...state,
        click_conversion_logs_loading: false,
        click_conversion_logs: conversion_logs
      }
    case DELETE_CLICK_CONVERSION_LOG_ERROR:
      return {
        ...state,
        click_conversion_logs_loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default Conversions
